export default __webpack_public_path__ + "static/media/ai.c4add60a.png";